import * as S from './style';

function Loader() {
    return <S.LoaderBackdrop >
    <S.Loader />
    </S.LoaderBackdrop>
}

export default Loader